import { render, staticRenderFns } from "./PatientSelection.vue?vue&type=template&id=366bafda&scoped=true&"
import script from "./PatientSelection.vue?vue&type=script&lang=js&"
export * from "./PatientSelection.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./PatientSelection.vue?vue&type=style&index=1&id=366bafda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366bafda",
  null
  
)

export default component.exports